import { DateRange } from "../../interfaces/type1/IQueryParams";
import DateUtils from "../../utils/DateUtils";

export interface ICached {
    Start: string,
    End: string, 
    DateRange: DateRange
}

export default class Cache 
{

    public static GetCache(): ICached | undefined 
    {

        let cacheJSON = sessionStorage.getItem('search-date-cache');

        if (!!cacheJSON) 
        {
            try {
                let cache: ICached = JSON.parse(cacheJSON) as ICached;
                let init = DateUtils.CastDateToAPIString(DateUtils.CastStringToDate(cache.Start));
                let end = DateUtils.CastDateToAPIString(DateUtils.CastStringToDate(cache.End));

                return {
                    Start: init,
                    End: end, 
                    DateRange : cache.DateRange
                }
            } catch { }            
        }

        
        return undefined;
    }

    public static SetCache(cache: ICached)
    {
         sessionStorage.setItem('search-date-cache', JSON.stringify(cache));
    }

}